<template>
  <b-container class="home-container container-xl vali-hollow-logo">
    <div class="text-left">
      <b-row>
        <b-col>
          <h1 class="mt-2">
            A mikro-, kis- és középvállalkozások modern üzleti és termelési kihívásokhoz való alkalmazkodását segítő
            fejlesztések támogatása a leghátrányosabb helyzetű régiókban
          </h1>

          <h2 class="mt-5">GINOP Plusz-1.2.3-21</h2>

          <p class="mt-5">
            A vállalkozói szektornak a gyorsuló technológiai, gazdasági és társadalmi változásokhoz való
            alkalmazkodóképessége fejlesztendő, ami hozzájárul a válságálló és fenntartható működéshez. A KKV-k körében
            ezért szükséges elősegíteni olyan vállalkozói kapacitásokba történő beruházások megvalósítását, melyek
            lehetővé teszik új technológiák alkalmazását és ezen keresztül a vállalati folyamatok hatékonyságának
            javítását. Fontos, hogy a technológiai fejlesztés egyidejűleg és szervesen egészüljön ki magas színvonalú
            vállalatirányítási gyakorlatok vagy újszerű üzleti modellek bevezetésével, szervezeti fejlesztéssel.
            <br />
            <br />
            A felhívással a Kormány a valós igényekhez igazodó megoldásokat kínál az eltérő piaci pozíciókban és
            különféle élethelyzetekben működő vállalkozások számára, a technológiai háttér megteremtésében, digitális
            megoldások bevezetésében, üzleti és termelési folyamatok megújításával, a vállalkozói szemlélet és
            készségek, menedzsment ismeretek, továbbá a szervezeti kultúra fejlesztésével.
            <br /><br />
            A célzott intézkedéssel a gazdaságilag, társadalmilag, infrastrukturális és munkaerő-piaci szempontból
            hátrányos helyzetű területeken tevékenykedő vállalkozások gazdasági szerepe kerül megerősítésre. A program
            kiemelten támogatja a négy legkevésbé fejlett régió területén (Dél-Dunántúl, Észak-Magyarország,
            Észak-Alföld, Dél-Alföld régiókban), valamint a szabad vállalkozási zónának minősülő vagy a kedvezményezett
            járásokba tartozó településeken megvalósuló fejlesztéseket.
          </p>

          <b-button
            class="mt-2"
            variant="primary"
            href="https://www.palyazat.gov.hu/GINOP_PLUSZ-1.2.3-21"
            target="_blank"
            >Tovább a pályázati felhívásra</b-button
          >

          <h5 class="mt-4">Ki nyújthat be támogatási kérelmet?</h5>

          <div class="bg-color-lightblue rounded p-5 mt-4">
            <div class="row">
              <div class="col-12 col-lg-4 mx-auto">
                <div class="row">
                  <div class="col-2 ">
                    <svg width="25" height="30" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12.5 5.35747V0.043457H0V23.9565H25V5.35747H12.5ZM5 21.2995H2.5V18.6425H5V21.2995ZM5 15.9855H2.5V13.3285H5V15.9855ZM5 10.6715H2.5V8.01447H5V10.6715ZM5 5.35747H2.5V2.70046H5V5.35747ZM10 21.2995H7.5V18.6425H10V21.2995ZM10 15.9855H7.5V13.3285H10V15.9855ZM10 10.6715H7.5V8.01447H10V10.6715ZM10 5.35747H7.5V2.70046H10V5.35747ZM22.5 21.2995H12.5V18.6425H15V15.9855H12.5V13.3285H15V10.6715H12.5V8.01447H22.5V21.2995ZM20 10.6715H17.5V13.3285H20V10.6715ZM20 15.9855H17.5V18.6425H20V15.9855Z"
                        fill="#00903C"
                      />
                    </svg>
                  </div>
                  <div class="col-10 text-green mt-1">
                    mikro-, kis-, és középvállalkozások
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ul class="mt-4">
            <li>amelyek rendelkeznek legalább 1 lezárt, teljes üzleti évvel,</li>
            <li>
              amelyek éves átlagos statisztikai állományi létszáma a támogatási kérelem benyújtását megelőző lezárt,
              teljes, de 2019-nél nem korábbi üzleti évben legalább 3 fő volt,
            </li>
            <li>
              amelyek Magyarország területén székhellyel rendelkező kettős könyvvitelt vezető gazdasági társaságok,
              kettős könyvvitelt vezető egyéni cégek, vagy az Európai Gazdasági Térség területén székhellyel és
              Magyarországon fiókteleppel rendelkező kettős könyvvitelt vezető gazdasági társaságok fióktelepei,
            </li>
            <li>amelyek nem tartoznak a KATA hatálya alá,</li>
            <li>
              amelyek esetében, amennyiben a GINOP vállalkozásfejlesztési prioritás (1. prioritás) felhívásainak
              keretében 2014-2019 között részükre megítélt támogatás(ok) összege meghaladja az utolsó 3 jóváhagyott
              (közgyűlés, taggyűlés, illetve a tulajdonosok által) lezárt, teljes üzleti év átlagos árbevételének
              50%-át, az ezen vállalkozások 2018-2020. közötti évekre vonatkozó bruttó hozzáadott érték növekedése
              (változása) legalább eléri vagy meghaladja a GDP növekedés mértékét (5,25 %) az azonos időszakban.
            </li>
          </ul>

          <h5 class="mt-4">Milyen tevékenységek támogathatóak?</h5>
          <ul class="mt-4">
            <li>Technológiai fejlesztést eredményező új eszközök beszerzése</li>
            <li>Infrastrukturális és ingatlan beruházás</li>
            <li>Tanácsadási szolgáltatások igénybevétele</li>
            <li>Képzési szolgáltatások igénybevétele</li>
            <li>Megújuló energiaforrást hasznosító technológiák alkalmazása</li>
            <li>Információs technológia-fejlesztés</li>
          </ul>

          <div class="row mt-4">
            <div class="col-lg-6 col-md-6 col-sm-12 p-3">
              <h5>Mennyi támogatást lehet igényelni?</h5>
              <div class="bg-color-lightblue p-5 text-green rounded bold mt-3 text-center">
                10 000 000 – 200 000 000 Ft
              </div>
              <p class="small mt-3">
                A visszatérítendő támogatás bizonyos feltételek teljesülése mellett részben vagy egészben vissza nem
                térítendővé válik. <br />
                A támogatás vissza nem térítendővé átfordításához olvassa el a
                <a
                  href="https://vali.hu/static/Eredmenyessegi_meres_utmutato_%E2%80%93_a_GINOP_Plusz_1.2.3-21_felhivas_6_szamu_szakmai_melleklete.pdf"
                  target="_blank"
                  class="bold"
                  >pályázati útmutatót</a
                >.
              </p>

              <h5>Kell-e önerő a projekthez?</h5>
              <div class="bg-color-lightblue p-5 text-green rounded bold mt-3 text-center">
                Igen, minimum 30% mértékben
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 p-3">
              <h5>Mennyi előleg igényelhető?</h5>
              <div class="bg-color-lightblue p-5 text-green rounded bold mt-3 text-center">
                100%, maximum 200 000 000 Ft
              </div>
            </div>
          </div>

          <h5 class="mt-4">Mikor lehet benyújtani a támogatási kérelmet?</h5>

          <svg width="1140" height="26" viewBox="0 0 1140 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="1140" height="26" rx="13" fill="#F2F8FA" />
            <rect x="97.5898" width="171.864" height="26" rx="13" fill="#00903C" />
            <rect x="583.91" width="172.727" height="26" rx="13" fill="#00903C" />
          </svg>

          <div class="row mt-3">
            <div class="col-2 offset-1">
              1. benyújtási szakasz: 2022. január 19. 08:00 - 2022. január 26. 12:00
            </div>

            <div class="col-2 offset-3">
              2. benyújtási szakasz: 2022. január 27. 08:00 - 2022. február 3. 12:00
            </div>
          </div>

          <h5 class="mt-5">Hol valósítható meg a projekt alatt?</h5>
          <p class="mt-4">
            Budapest kivételével Magyarország egész területén. Az 1. benyújtási szakaszra kizárólag azon támogatást
            igénylők nyújthatnak be támogatási kérelmet, amelyek
            <b>Dél-Dunántúl, Észak-Magyarország, Észak-Alföld, Dél-Alföld régiók</b> egyikében valósítják meg
            fejlesztéseiket. <br />
            Rendelkezésre álló keret: 80 milliárd Ft <br />
            A 2. benyújtási szakaszra kizárólag azon támogatást igénylők nyújthatnak be támogatási kérelmet, amelyek
            <b>Közép-Dunántúl, Nyugat-Dunántúl, Pest régiók</b> egyikében valósítják meg fejlesztéseiket.
            <br />
            Rendelkezésre álló keret: 20 milliárd Ft
          </p>
          <h5 class="mt-5">Kötelező vállalás</h5>
          A támogatást igénylőnek vállalnia kell, hogy termelő/szolgáltató tevékenységéhez kapcsolódóan korszerű
          vállalati technológiai megoldásokat alkalmaz. A felhívás szempontjából korszerű vállalati technológiának
          minősülő megoldásokat tartalmazó útmutatót itt találja:

          <div
            class="bg-color-lightblue rounded p-3 text-green mt-4"
            @click="
              openLinkNewTab(
                'https://vali.hu/static/Palyazoi_kezikonyv_a_korszeru_vallalati_technologiai_megoldasok_alkalmazasahoz_%E2%80%93_GINOP_Plusz_1.2.3-21.pdf'
              )
            "
            style="cursor: pointer"
          >
            Pályázói kézikönyv a korszerű vállalati technológiai megoldások alkalmazásához
            <arrow-right-icon />
          </div>

          <h5 class="mt-5">Legvége, egyéb fontos tudnivalók</h5>
          <p class="mt-4">
            A projekt fizikai befejezésére a megkezdésétől számított legfeljebb
            <font class="text-green bold">24 hónap</font> áll rendelkezésre. <br />
            Várhatóan
            <font class="text-green bold">800-2500 darab</font> projekt kap támogatást.
          </p>

          <h5 class="mt-5">Ügyfélszolgálat elérhetősége</h5>
          <p class="mt-4">
            Széchenyi Terv Plusz ügyfélszolgálat: 06/1 896-0000 (hétfőtől csütörtökig 8.30-16 óra között, pénteken 8.30-
            14 óra között)
          </p>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue'

export default {
  name: 'GinopPlusz-2.1.3-21',
  components: {
    ArrowRightIcon
  },
  methods: {
    openLinkNewTab(link) {
      const win = window.open(link, '_blank')
      win.focus()
    }
  }
}
</script>

<style scoped>
ul {
  padding-left: 40px;
}
li {
  margin-bottom: 5px;
}
.bold {
  font-weight: bold;
}

.btn {
  line-height: 2rem;
}
</style>
